module.exports = __webpack_public_path__ + "media/images/upload_course-07426c62.png";